// Fuel Efficiency Volume units with conversion factors to joule per liter (J/L)
export const fuelEfficiencyVolumeUnits = [
  { id: 'joule-per-liter', name: 'Joule per Liter', symbol: 'J/L', plural: 'Joules per Liter', toBase: 1 },
  { id: 'joule-per-cubic-meter', name: 'Joule per Cubic Meter', symbol: 'J/m³', plural: 'Joules per Cubic Meter', toBase: 0.001 },
  { id: 'kilojoule-per-liter', name: 'Kilojoule per Liter', symbol: 'kJ/L', plural: 'Kilojoules per Liter', toBase: 1000 },
  { id: 'megajoule-per-liter', name: 'Megajoule per Liter', symbol: 'MJ/L', plural: 'Megajoules per Liter', toBase: 1000000 },
  { id: 'calorie-per-milliliter', name: 'Calorie per Milliliter', symbol: 'cal/mL', plural: 'Calories per Milliliter', toBase: 4.184 },
  { id: 'kilocalorie-per-liter', name: 'Kilocalorie per Liter', symbol: 'kcal/L', plural: 'Kilocalories per Liter', toBase: 4184 },
  { id: 'btu-per-cubic-foot', name: 'BTU per Cubic Foot', symbol: 'BTU/ft³', plural: 'BTUs per Cubic Foot', toBase: 37.258945 },
  { id: 'btu-per-gallon-us', name: 'BTU per Gallon (US)', symbol: 'BTU/gal', plural: 'BTUs per Gallon (US)', toBase: 278.7167 },
  { id: 'btu-per-gallon-uk', name: 'BTU per Gallon (UK)', symbol: 'BTU/gal UK', plural: 'BTUs per Gallon (UK)', toBase: 231.8058 },
  { id: 'therm-per-gallon', name: 'Therm per Gallon', symbol: 'therm/gal', plural: 'Therms per Gallon', toBase: 27871670 },
];

export const popularFuelEfficiencyVolumeConversions = [
  { from: 'joule-per-liter', to: 'kilojoule-per-liter' },
  { from: 'kilojoule-per-liter', to: 'megajoule-per-liter' },
  { from: 'megajoule-per-liter', to: 'kilojoule-per-liter' },
  { from: 'btu-per-gallon-us', to: 'joule-per-liter' },
  { from: 'kilocalorie-per-liter', to: 'joule-per-liter' },
  { from: 'joule-per-cubic-meter', to: 'joule-per-liter' },
];

export const getUnitById = (id) => fuelEfficiencyVolumeUnits.find(unit => unit.id === id);

export const convertFuelEfficiencyVolume = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert fuel efficiency volume units and learn the conversion formula.`;
};
